import React, { Component } from 'react';
import './ContributionWindowClosed.scss';
import Button from '../../../../components/Shared/Button/Button';

export class ContributionWindowClosed extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = () => {
    const { closeContributionWindowAlert } = this.props;
    closeContributionWindowAlert();
    // eslint-disable-next-line no-restricted-globals
    location.reload(true);
  };

  render() {
    const {
      IRALimit: {
        windowCheck: { iraContributionPeriodCutoffDate },
      },
    } = this.props;
    const cutOffDate = iraContributionPeriodCutoffDate.replace(/-/g, '/');
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    return (
      <div className="contrib-win-closed">
        <div className="cwc-heading">
          <p>The IRA contribution window for {previousYear} has closed.</p>
        </div>
        {/*<div className="cwc-dash" />*/}
        <div className="cwc-subheading">
          <p>
            The {previousYear} IRA contribution window closed at midnight on{' '}
            {cutOffDate}. To continue, adjust your contribution to include only
            the {currentYear} tax year.
          </p>
        </div>
        <Button
          id="cwc-close-link"
          buttonType="primary"
          className="btn-trp-primary"
          onClick={this.handleClick}
        >
          Adjust Contribution
        </Button>
      </div>
    );
  }
}

export default ContributionWindowClosed;
